const processSubjectsEntity = (feedBlock) => ({
  label: feedBlock.label || feedBlock.extraBlockInfo.label || '',
  type: feedBlock.type,
  data: feedBlock.data.map((subject) => ({
    ...subject,
    data: subject.data.map((info) => ({
      ...info,
      icon_colour: info.iconColour,
      icon_url: info.iconUrl
    })),
    extra_info: subject.extraInfo
  })),
  extraBlockinfo: {
    ...(feedBlock.extraBlockInfo || {})
  }
});

export default processSubjectsEntity;
